import {axiosBffFetch} from '../../axios/axiosBffFetch';
import {requestContext} from '../../common/requestContext';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {AuthRequestInfoVo} from '../../common/shared/api/nicolas/vo/AuthRequstInfoVo.interface';
import {AuthRequestType, CertType} from '../../graphql/generated/types';

const CERT_TYPE_MAP: Partial<Record<CertType, string>> = {
  [CertType.DreamSecurity]: 'DREAMSECURITY',
  [CertType.KakaoBank]: 'KAKAOBANK',
  [CertType.Nice]: 'NICE',
};

/**
 * 본인인증 요청 정보 준비
 *
 * Origin: pageNicolasApi.prepareAuthRequestInfo
 * API: POST /api/v4/auth/req/info
 */
export async function postAuthReqInfo({
  certType,
  authRequestType,
  returnUrl,
}: {
  certType: CertType;
  authRequestType: AuthRequestType;
  returnUrl?: string | null;
}): Promise<AuthRequestInfoVo & ApiResultVo> {
  const cert_type = CERT_TYPE_MAP[certType];

  const response = await axiosBffFetch('/api/gateway/api/v4/auth/req/info', {
    method: 'POST',
    data: {
      cert_type,
      auth_request_type:
        authRequestType === AuthRequestType.Parents ? 'PARENTS' : 'SELF',
      access_token: requestContext.requestInfo?.kakaoAuth?.accessToken,
      app_user_id: requestContext.requestInfo?.kakaoAuth?.appUserId,
      ...((cert_type === 'NICE' || cert_type === 'KAKAOBANK') && {
        callback_url: returnUrl,
      }),
    },
  });
  return response.data;
}
